export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/ob-step-5.png?d8c053004b9e67f6b6bb68cbbb5f0754";